
import { JobRequirement } from "@pages/hiringCompany/requirements/candidates/candidates.types";

export const convertJobData = (input: JobRequirement) => {
  return {
    title: input.title,
    jobRequirementId: input?._id,
    description: `<p>${input.description}</p>`, // Wrap with <p> for HTML
    location: input.location,
    salary: {
      min: input.salary?.min ?? 0,
      max: input.salary?.max ?? 0,
    },
    workPlaceOption: input.workPlaceOption,
    industryType: input.industryType,
    jobType: input.jobType,
    status: input.status,
    createdBy: input.createdBy,
    isSalaryHidden: false,
    extensionNotified: false,
    hasReferral: false,
    currency: "£",
    positionLevel: 4,
    isStartUp: false,
    isInternship: false,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
    refNo: input.refNo,
    skills: input.skills.map((skill: any) => ({
      title: skill.title,
      type: skill.type,
      rating: skill.rating,
      years: skill.years,
      lastUsed: skill.lastUsed,
    })),
    companyId: input?.company?._id,
    creatorDetails: {
      _id: input.createdBy,
      firstName: input.company.createdBy, // or get from elsewhere
      lastName: input.company.createdBy, // or get from elsewhere
      companyName: input.company?.name ?? "",
    },
    companyDetails: {
      nam: input?.company?.name,
      refNo: input?.company?.refNo,
    },
    applicantData: [],
  };
};
